import Enrolment from "./Enrolment";

export default function ReEnrolmentForm() {
  return (
    <Enrolment reenrol={true} />
  );
};
